import React from "react";
import parse from "html-react-parser";
import { useMediaQuery } from "react-responsive";

//styles
import "./format-2.style.scss";

//React Bootstrap
import { Container, Row, Col } from "react-bootstrap";

const Format2 = (props) => {

  const checkValue = (val) => {
    return val && val !== "" ? true : false;
  };

  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-width: 992px)",
  });
  
  const checkImageMobile = () => {
    if(isTabletOrMobileDevice && checkValue(props.item.image_mobile)){
      return props.item.image_mobile;
    }
    else{
      return props.item.image;
    }
  }

  return (
    <Container bsPrefix="container-xl format-2"  key={props.keyUniq}>
      {/* IMAGE */}
      {props.item.image && props.item.image !== "" && (
        <Row className="justify-content-center">
          <img src={checkImageMobile()} className="img-fluid" alt="" />
        </Row>
      )}

      <div className="content">
        {/* TITLE */}
        <Row className="title">
          <h1>{props.item.name}</h1>
        </Row>

        <Row className="divider" />

        {/* DESCRIPTION */}
        {props.item.desc && props.item.desc !== "" && (
          <Row className="desc">{parse(props.item.desc)}</Row>
        )}
      </div>
    </Container>
  );
};

export default Format2;
